module.exports = __webpack_public_path__ + "static/media/w5.f0f2b5da.svg";